<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <div class="zv-breadcrumb-wrap">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/data-input/eventList' }"
              >事件库</el-breadcrumb-item
            >
            <el-breadcrumb-item>{{ this.isEdit ? this.models == 'look' ?'查看事件' : '更新事件' : '新增事件' }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <!-- <div class="zv-page-title">新增事件</div> -->
        <el-form
          ref="myForm"
          :model="formData"
          :rules="formRules"
          :label-width="formLabelWidth"
        >
          <el-form-item label="标题:" prop="event_name">
            <el-input
              class="el-input-width-1205"
              v-model="formData.event_name"
            ></el-input>
          </el-form-item>
          <div class="zv-flex-wrap">
            <div class="zv-form-item-label">事发地址:</div>
            <div class="zv-flex-1">
              <div
                class="zv-flex-wrap"
                v-for="(addressItem, index) in formData.addressData"
                :key="addressItem.uuid"
              >
                <el-form-item
                  label-width="auto"
                  :prop="'addressData.' + index + '.address1'"
                  :rules="{
                    required: true,
                    message: '地址不能为空',
                    trigger: 'change'
                  }"
                >
                  <el-select
                    placeholder="选择地址"
                    v-model="addressItem.address1"
                    filterable
                    @change="getEventFieldOptionList"
                  >
                    <el-option
                      v-for="item in addressSelectData"
                      :key="item.id"
                      :label="item.full_area_name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                  <el-button style="margin-left: 10px" @click="goOutPage">新增</el-button>
                  <el-button style="margin-left: 10px" @click="removeLocalFn">刷新</el-button>
                </el-form-item>
                <el-form-item
                  :label-width="formItemPadding"
                  :prop="'addressData.' + index + '.address2'"
                >
                  <el-input
                    v-model="addressItem.address2"
                    placeholder="县"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  :label-width="formItemPadding"
                  :prop="'addressData.' + index + '.address3'"
                >
                  <el-input
                    v-model="addressItem.address3"
                    placeholder="乡镇"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  :label-width="formItemPadding"
                  :prop="'addressData.' + index + '.address4'"
                >
                  <el-input
                    v-model="addressItem.address4"
                    placeholder="社区"
                  ></el-input>
                </el-form-item>
                <!--  :rules="{
                    required: true,
                    message: '经度不能为空',
                    trigger: 'blur'
                  }" -->
                <el-form-item
                  :label-width="formItemPadding"
                  :prop="'addressData.' + index + '.longitude'"
                >
                  <el-input
                    v-model="addressItem.longitude"
                    placeholder="经度"
                  ></el-input>
                </el-form-item>
                <!-- :rules="{
                    required: true,
                    message: '纬度不能为空',
                    trigger: 'blur'
                  }" -->
                <el-form-item
                  :label-width="formItemPadding"
                  :prop="'addressData.' + index + '.latitude'"
                >
                  <el-input
                    v-model="addressItem.latitude"
                    placeholder="纬度"
                  ></el-input>
                </el-form-item>
                <el-form-item :label-width="formItemPadding">
                  <el-button type="primary" @click="addressBtnClick(index)">{{
                    index == 0 ? "添加" : "删除"
                  }}</el-button>
                </el-form-item>
              </div>
            </div>
          </div>
          <el-form-item label="事发时间:" prop="event_time_start_str">
            <el-date-picker
              class="el-input-width1"
              v-model="formData.event_time_start_str"
              type="datetime"
              placeholder="选择事发时间"
              :picker-options="pickerOptions"
              :value-format="dpValueFormat"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="事件完结时间:" prop="event_time_end_str">
            <el-date-picker
              class="el-input-width1"
              v-model="formData.event_time_end_str"
              type="datetime"
              placeholder="选择事件完结时间"
              :picker-options="pickerOptions"
              :value-format="dpValueFormat"
              :default-time="'23:59:59'"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="事件持续时间:">
            <el-input
              class="el-input-width1"
              :value="eventLastTime"
              readonly
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="影响范围性质:" prop="event_affect_area_type">
            <el-radio-group v-model="formData.event_affect_area_type">
              <el-radio-button
                v-for="item in effectAreaType"
                :label="item.value"
                :key="item.value"
                >{{ item.label }}</el-radio-button
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item label="影响完结时间:" prop="event_affect_time_end_str">
            <el-date-picker
              class="el-input-width1"
              v-model="formData.event_affect_time_end_str"
              type="datetime"
              placeholder="选择影响完结时间"
              :picker-options="pickerOptions"
              :value-format="dpValueFormat"
              :default-time="'23:59:59'"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="影响持续时间:">
            <el-input
              class="el-input-width1"
              v-model="eventEffectLastTime"
              readonly
              disabled
            ></el-input>
          </el-form-item>
          <!-- 1.3 2020.6.10新增 -->
          <el-form-item label="文章来源:" prop="event_source">
            <el-input
              class="el-input-width1"
              v-model="formData.event_source"
            ></el-input>
          </el-form-item>
           <el-form-item label="来源地址:" prop="event_source_url">
            <el-input
              class="el-input-width1"
              v-model="formData.event_source_url"
            ></el-input>
          </el-form-item>
          <el-form-item label="文章原文:">
            <el-input
              class="el-textarea-width1"
              v-model="formData.event_source_content"
              type="textarea"
              :rows="5"
              placeholder="请输入原文"
              @mouseup.native="copyTextFn"
            ></el-input>
           <el-button style="margin-left: 10px" type="primary" @click="tagListShow = true">{{tagsArr.length > 0? '查看标签':'设置标签'}}</el-button>
           <el-button style="margin-left: 10px" type="primary" @click="tagListShow = false">收起</el-button>
           <div style="margin-top: 15px" v-if="tagListShow">
             <el-button plain v-for="(item,index) in tagListArr" :key="index" @click="selectTagFn(item)">{{item.tag_name}}</el-button>
             <el-button style="margin-left: 10px" type="primary" @click="dialogTags = true">新增标签</el-button>
             <div style="margin-top: 15px">标签：<span style="font-size: 12px;color: red">(注意：对文章内容进行修改后，请点击标签删除相关标签数据)</span></div>
             <div style="margin-top: 10px" v-for="(item,index) in tagsArr" :key="'tages'+index">
               <el-button plain @click="tagsDelFn(item,index)">{{item.tag_name}}</el-button>
               <span style="margin-left: 15px;color: gray">{{item.tag_value}}</span>
             </div>
           </div>
          <el-dialog
            title="新增标签"
            :visible.sync="dialogTags"
            width="20%"
            >
            <label>标签名：</label>
            <el-input placeholder="请输入标签名" v-model="tags_name"></el-input>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogTags = false">取 消</el-button>
              <el-button type="primary" @click="addTagsFn">确 定</el-button>
            </span>
          </el-dialog>
          </el-form-item>

          <el-form-item label="快讯描述:">
            <el-input
              class="el-textarea-width1"
              v-model="formData.event_news_description"
              type="textarea"
              :rows="4"
              placeholder="请输入快讯描述"
            ></el-input>
          </el-form-item>

          <el-form-item label="事件描述:" prop="event_description">
            <el-input
              class="el-textarea-width1"
              v-model="formData.event_description"
              type="textarea"
              :rows="4"
              placeholder="请输入事件描述"
            ></el-input>
          </el-form-item>
          
          <div class="zv-flex-wrap">
            <div class="zv-form-item-label">涉事人数:</div>
            <div class="zv-flex-wrap zv-flex-1 style-col-5">
              <div
                class="zv-form-item-col"
                v-for="item in involvedData1"
                :key="item.key"
              >
                <el-form-item label-width="auto" :prop="item.key">
                  <el-input
                    v-model.number="formData[item.key]"
                    type="input"
                    :value="formData[item.key]"
                  >
                    <template slot="prepend">{{ item.text }}</template>
                    <template slot="append">人</template>
                  </el-input>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="zv-flex-wrap">
            <div class="zv-form-item-label">华人涉事人数:</div>
            <div class="zv-flex-wrap zv-flex-1 style-col-5">
              <div
                class="zv-form-item-col"
                v-for="item in involvedData2"
                :key="item.key"
              >
                <el-form-item label-width="auto" :prop="item.key">
                  <el-input
                    v-model="formData[item.key]"
                    type="input"
                    :value="formData[item.key]"
                  >
                    <template slot="prepend">{{ item.text }}</template>
                    <template slot="append">人</template>
                  </el-input>
                </el-form-item>
              </div>
            </div>
          </div>
          <el-form-item label="是否流血事件:">
            <el-switch
              disabled
              :value="isBleeding"
              active-text="是"
              inactive-text="否"
            >
            </el-switch>
          </el-form-item>
          <el-form-item label="是否减分项:">
            <el-radio-group v-model="isReduce">
              <el-radio-button
                v-for="item in reduceData"
                :label="item.value"
                :key="item.value"
                >{{ item.label }}</el-radio-button
              >
            </el-radio-group>
          </el-form-item>
          <template v-if="isShowReducePart">
            <el-form-item label="减分项性质:">
              <el-radio-group v-model="reduceProp">
                <el-radio-button
                  v-for="item in reducePropData"
                  :label="item.value"
                  :key="item.value"
                  >{{ item.label }}</el-radio-button
                >
              </el-radio-group>
            </el-form-item>
            <div class="zv-flex-wrap">
              <div class="zv-form-item-label">减分类型:</div>
              <div class="zv-form-item-content">
                <el-form-item label-width="auto">
                  <el-radio-group v-model="formData.event_related_type">
                    <el-radio-button
                      v-for="item in reduceTypeData"
                      :label="item.value"
                      :key="item.value"
                      >{{ item.label }}</el-radio-button
                    >
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
            <el-form-item
              label="针对事件ID:"
              label-width="225px"
              prop="event_related_id_input"
              v-if="formData.event_related_type == 0"
            >
              <el-input
                class="el-input-width-400"
                v-model="formData.event_related_id_input"
                placeholder="输入ID数字，多个用英文,隔开"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="一级事件类型:"
              label-width="240px"
              prop="event_related_id_select_arr"
              v-else-if="formData.event_related_type == 1"
            >
              <el-select
                class="el-selet-width-400"
                placeholder="请选择事件类型(可多选)"
                v-model="formData.event_related_id_select_arr"
                multiple
                filterable
              >
                <el-option
                  v-for="item in riskTypeData"
                  :key="item.id"
                  :label="item.full_risk_name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- lafite 5.22新增条件型 -->
            <el-form-item
              v-else
              v-for="(itemMain,index) in conditionalItem" :key="index+10"
            >
              <div class="condition">
                <el-select
                  v-if="index != 0"
                  class="el-selet-width-100"
                  v-model="andValue"
                  filterable
                >
                  <el-option
                    v-for="item in andArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-select
                  class="el-selet-width-200"
                  placeholder="选择事件类型"
                  v-model="itemMain.event"
                  @change="conditionSelect"
                  filterable
                >
                  <el-option
                    v-for="item in riskTypeData"
                    :key="item.id"
                    :label="item.full_risk_name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <el-select
                  class="el-selet-width-200"
                  placeholder="选择参考因素"
                  v-model="itemMain.refer"
                  @change="consultFn($event)"
                  filterable
                >
                  <el-option
                    v-for="item in eventRiskFieldLists"
                    :key="item.risk_field_id"
                    :label="item.field_name"
                    :value="item.risk_field_id"
                  >
                  </el-option>
                </el-select>
                <el-select
                    class="el-selet-width-200"
                    placeholder="选择因素值"
                    v-model="itemMain.factor"
                    filterable
                  >
                    <el-option
                      v-for="item in eventFieldSelects"
                      :key="item.id"
                      :label="item.risk_field_value"
                      :value="item.risk_field_value"
                    >
                    </el-option>
                </el-select>
                <el-button type="primary" @click="conditionFn(index)">{{index == 0 ?'添加':'删除'}}</el-button>
              </div>
            </el-form-item>
            <el-form-item label="减分程度:" prop="event_related_level">
              <el-radio-group v-model="formData.event_related_level">
                <el-radio-button
                  v-for="item in eventRelatedLevel"
                  :label="item.value"
                  :key="item.value"
                  >{{ item.label }}</el-radio-button
                >
              </el-radio-group>
            </el-form-item>
          </template>
          <el-form-item label="事件类型:" prop="risk_id_arr">
            <el-select
              class="el-selet-width-800"
              placeholder="请选择事件类型(可多选)"
              v-model="formData.risk_id_arr"
              multiple
              filterable
              @change="getEventFieldOptionList"
            >
              <el-option
                v-for="item in riskTypeData"
                :key="item.id"
                :label="item.full_risk_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <template v-if="eventRiskFieldList.length">
            <div
              v-for="(eventTypeItem, eIndex) in rendEventTypeArr"
              :key="eventTypeItem.id"
              style="padding-bottom: 10px;"
            >
              <div
                v-for="riskItem in eventRiskFieldList[eIndex]"
                :key="riskItem.risk_id"
              >
                <div class="event-risk-wrap">
                  <div class="event-risk-inner">
                    <!-- <el-tag>{{ riskItem.full_risk_name }}</el-tag> -->
                    <!-- <el-tag type="success">{{ eventTypeItem.text }}</el-tag> -->
                    {{ riskItem.full_risk_name + " " + eventTypeItem.text }}
                  </div>
                </div>
                <el-form-item
                  v-for="fieldItem in riskItem.field_list"
                  :key="fieldItem.risk_field_id"
                  :label="riskItem.full_risk_name + '•' + fieldItem.field_name"
                >
                  <div class="form-label-lh-auto" slot="label">
                    {{ riskItem.full_risk_name + "•" + fieldItem.field_name }}
                  </div>
                  <el-select
                    class="el-selet-width-800"
                    :placeholder="'请选择' + fieldItem.field_name"
                    v-model="
                      eventFieldSelect[
                        eventTypeItem.id +
                          '_' +
                          riskItem.risk_id +
                          '_' +
                          fieldItem.risk_field_id
                      ]
                    "
                    multiple
                    filterable
                  >
                    <el-option
                      v-for="optionItem in fieldItem.option_list"
                      :key="optionItem.id"
                      :label="optionItem.risk_field_value"
                      :value="optionItem.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <el-form-item label="是否涉华:">
              <el-switch
                disabled
                :value="isSheHua"
                active-text="是"
                inactive-text="否"
              >
              </el-switch>
            </el-form-item>
          </template>
          <div class="zv-flex-wrap" style="padding-top: 10px;">
            <div class="zv-form-item-label">关联资讯:</div>
            <div
              class="zv-form-item-content"
              style="display: block; max-width: 1205px;"
            >
              <div style="padding-bottom: 10px;">
                <el-button
                  type="primary"
                  size="mini"
                  @click="openAddNewsTableClick"
                  >添加关联资讯</el-button
                >
              </div>
              <zv-table :table="selectedNewsTable" ref="snDataTable">
              </zv-table>
            </div>
          </div>
           <div class="zv-flex-wrap" style="padding-top: 10px;">
            <div class="zv-form-item-label">历史版本:</div>
            <div
              class="zv-form-item-content"
              style="display: block; max-width: 1205px;"
            >
              <el-table
                :data="logsArr"
                style="width: 100%">
                <el-table-column
                  label="更新时间"
                  width="180">
                  <template slot-scope="scope">
                    <span>{{$commFunc.formatDate(scope.row.add_time)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="diff"
                  label="更新内容"
                  min-width="180">
                </el-table-column>
                <el-table-column
                  prop="bulletin"
                  label="关联快讯"
                  min-width="120"
                  :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                  prop="event_source"
                  label="文章来源"
                  width="180"
                  >
                </el-table-column>
                <el-table-column
                  prop="event_source_url"
                  label="文章地址"
                  width="180"
                  :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                  prop="username"
                  label="操作人"
                  width="120"
                  >
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="80">
                  <template slot-scope="scope">
                    <span v-if="scope.row.id != id" @click.prevent="lookFn(scope.row)" style="color: #3ae2c4;cursor: pointer;">查看</span>
                    <span v-else style="color: gray">查看</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <el-form-item label-width="auto" v-if="models != 'look'" class="fi-flex-center paddint-t-30">
            <el-button @click="doCancel">返回</el-button>
            <el-button type="primary" @click="doSubmit">仅提交</el-button>
             <el-button type="primary" @click="newsletterFn">提交并生成快讯</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <zv-dialog
      width="700px"
      title="关联资讯"
      :showDialog.sync="showNewsTableDialog"
    >
      <div slot="content">
        <zv-table :table="dialogNewsTable" ref="dnDataTable" @on-selection-change="dialogNewsSelectChange">
        </zv-table>
      </div>
      <div slot="btns">
        <el-button @click="showNewsTableDialog = false">取消</el-button>
        <el-button type="primary" @click="confimAddRelatedNews"
          >确定</el-button
        >
      </div>
    </zv-dialog>
  </div>
</template>
<script>
import api from "./api";
import formPageMixin from "@/mixins/formPageMixin";
import TipUtil from "@/utils/utils/TipUtil";
import localData from "@/utils/utils/localData";
export default {
  name: "CreateEvent",
  mixins: [formPageMixin],
  components: {},
  data() {
    let vm = this;
    return {
      models: '',
      logsArr: [],
      tagsArr: [],
      tagListShow: false,
      selectTxt: '',
      tags_name: '',
      dialogTags: false,
      tagListArr: [],
      conditionIndex: 1,
      id: '',   // 事件编辑时id
      isEdit: false,   // 是否为编辑
      addressSelectData: [], // 选择地址下拉数据
      areaDataLoaded: false, // 异步获取地址下拉数据是否完成
      eventAddressItem: {
        uuid: '',
        address1: '',   // 省
        address2: '',   // 县
        address3: '',   // 乡镇
        address4: '',   // 社区
        longitude: '',   // 经度
        latitude: '',   // 纬度
      },
      eventAddressArr: [],
      effectAreaType: vm.$enums.AreaType.forEventList,
      involvedData1: [], // 涉事人数数据
      involvedData2: [], // 华人涉事人数数据
      formDataOri: {},
      formData: {
        addressData: [],
        event_name: "", // 事件标题
        event_time_start: "", // 事件发生时间（时间戳）, 提交后台
        event_time_start_str: "", // 事件发生时间（时间格式）
        event_time_end: "", // 事结束生时间（时间戳）, 提交后台
        event_time_end_str: "", // 事结束生时间（时间格式）
        event_description: "", // 事件详细介绍
        event_source: "", // 事件来源
        event_source_url: "", // 事件来源URL
        affect_area_id: "", // 事件发生地区ID 可以多选 用,隔开
        affect_area_address: "", // 事件发生地址
        affect_area_address_lat: "", // 事件发生纬度
        affect_area_address_lng: "", // 事件发生经度
        event_affect_time_end: "", // 响结束时间（时间戳）, 提交后台
        event_affect_time_end_str: "", // 响结束时间（时间格式）
        event_affect_area_type: "", //  影响地区范围
        event_related_positive_affect: "", // 是否关联 -1非关联事件（默认） 0非正向关联 1 正向关联
        event_related_type: 0, // 0 指定 1通用
        event_related_id: "", //  关联事件 非-1 是指定事件 -1表示同类型事件
        event_related_id_input: "", // 输入框中针对事件ID
        event_related_id_select: "", // 选择框中通用事件ID,用逗号隔开
        event_related_id_select_arr: [], // 选择框中通用事件ID数组
        event_related_level: "", // 关联事件影响等级 0低、1一般、2中等、3较高、4极高
        risk_id: "", // 事件关联风险分类ID 可以多选 用,隔开
        risk_id_arr: [], // 事件关联风险分类ID数组，表单中用不提交后台
        related2china: '', // 是否涉华
        related_news_id: '', // 关联新闻id
      },
      formRules: {
        event_name: [
          {
            required: true,
            message: "事件标题不能为空",
            trigger: "blur"
          }
        ],
        event_time_start_str: {
          required: true,
          message: "事件发生时间不能为空",
          trigger: "blur"
        },
        event_description: {
          required: true,
          message: "事件描述不能为空",
          trigger: "blur"
        },
        event_affect_area_type: {
          required: true,
          message: "影响范围性质不能为空",
          trigger: "change"
        },
        risk_id_arr: {
          required: true,
          message: "事件类型不能为空",
          trigger: "change"
        },
        event_source: {
          required: true,
          message: "文章来源不能为空",
          trigger: "blur"
        },
        event_source_url: {
          required: true,
          message: "来源地址不能为空",
          trigger: "blur"
        }
      },
      andValue: 0,
      andArr: [
        { label: "与", value: 0 },
        { label: "或", value: 1 }
      ],
      reduceData: [
        { label: "是", value: 1 },
        { label: "否", value: 0 }
      ],
      isReduce: 0, // 2020.04.21 修改默认值 是否减分项
      reducePropData: [
        { label: "正面", value: 1 },
        { label: "负面", value: 0 }
      ],
      reduceProp: 1, // 减分性质
      reduceTypeData: [
        { label: "针对型", value: 0 },
        { label: "通用型", value: 1 },
        { label: "条件型", value: 2 }
      ],
      reduceType: 0, // 减分类型
      eventRelatedLevel: vm.$enums.EventRelatedLevel.list, // 减分程度
      riskTypeData: [], // 关联事件数据数组
      eventRiskFieldList: [], // 事件参考因素值
      eventRiskFieldLists: [], // 条件型 - 事件参考因素值
      eventRiskFieldOptions: [], // 全部下拉值数组
      eventRiskFieldOptions2: [], //条件型 -  全部下拉值数组
      eventFieldSelects: [], // 条件型 - 因素值
      conditionalItem: [{
        event: '',   // 事件类型
        refer: '',   // 参考因素
        factor: ''  // 因数值
      }],
      rendEventTypeArr: [ // 显示的事件类型，（通用，华人）
        { id: 0, text: "通用", target_type: 1 },
        { id: 1, text: "华人", target_type: 2 }
      ],
      eventFieldSelect: {}, // 通用、华人事件参考因素值
      // chineseFieldSelect: {}, // 华人事件参考因素值
      isSheHua: false,  // 是否涉华
      newsTableOri: {
        api: api.getEventRelatedNewsList,
        query: {},
        searchData: [],
        autoHeight: true,
        autoLoading: false,
        hidePagination: true,
        rowIdKey: 'news_id',
        data: [],
        columns: [
          {
            title: "标题",
            key: "title",
            minWidth: "200",
            showTooltip: true
          },
          {
            title: "发生时间",
            key: "occur_time",
            minWidth: "100",
            showTooltip: true
          },
          // {
          //   title: "发生地点",
          //   key: "loc_name",
          //   showTooltip: true
          // }
        ]
      },
      selectedNewsTable: {},
      dialogNewsTable: {},
      showNewsTableDialog: false,  // 是否弹出选择关联资讯弹窗
      dialogSelectedNewsArr: [],   // 弹出窗选中资讯
    };
  },
  computed: {
    // 事件持续时间
    eventLastTime() {
      return this.$commFunc.dateDiffStr(this.formData.event_time_start_str, this.formData.event_time_end_str)
    },

    // 事件影响持续时间
    eventEffectLastTime() {
      return this.$commFunc.dateDiffStr(this.formData.event_time_start_str, this.formData.event_affect_time_end_str)
    },

    isShowReducePart() {
      return this.isReduce == 1
    },

    isBleeding() {
      // 如果死亡人数大于0则为流血事件
      if (this.formData.event_involved_people_death || this.formData.event_involved_chinese_people_death) {
        return true
      }
      return false;
    },
    // isSheHua() {

    // },
  },

  watch: {
    "eventFieldSelect": {
      handler: function(newVal) {
        let retVal = false
        for(let key in newVal) {
          let keyArr = key.split('_')
          if (keyArr.length && keyArr[0] == 1 && newVal[key].length > 0) {
            retVal = true
          }
        }
        this.isSheHua = retVal
      },
      deep: true
    }
  },

  methods: {
    assignInvolvedDataKey(data) {
      let retObj = {};
      data.forEach(item => {
        retObj[item.key] = "";
      });
      this.formData = Object.assign({}, this.formData, retObj);
    },

    async initCommonData() {
      this.involvedData1 = this.processInvolvedData(this.$enums.InvolvedType.commonPrefix);
      this.involvedData2 = this.processInvolvedData(this.$enums.InvolvedType.shehuaPrefix);
      // this.formData = this.$_.cloneDeep(this.formDataOri);
      this.assignInvolvedDataKey(this.involvedData1);
      this.assignInvolvedDataKey(this.involvedData2);
      this.initRelatedNewsData()

      // 获取城市列表
      this.$commFunc.getAreaList().then(resData => {
        this.areaDataLoaded = true
        this.addressSelectData = resData
      })

      this.$commFunc.getRiskTypeList().then(resData => {
        this.riskTypeData = resData
      })
    },

    initRelatedNewsData() {
      let vm = this
      let clonedObj1 = this.$_.cloneDeep(this.newsTableOri)
      clonedObj1.columns.push({
        title: "操作",
        fixed: "right",
        minWidth: "150",
        render(h, ctx) {

          const delBtn = h(
            "el-button",
            {
              attrs: {
                type: "text"
              },
              on: {
                click: vm.doSelectedNewsItem.bind(this, ctx.$index)
              }
            },

            "删除"
          );

          let arr = [];
          arr.push(delBtn);
          return h("span", arr);
        }
      })

      this.selectedNewsTable = clonedObj1

      let clonedObj2 = this.$_.cloneDeep(this.newsTableOri)
      clonedObj2.searchData = [{
        type: "input",
        model: "news_id",
        placeholder: "多个id用英文逗号隔开"
      }]

      clonedObj2.columns.unshift({
        type: 'selection'
      })

      this.dialogNewsTable = clonedObj2
    },

    initAddData() {
      this.addAdressItem()
      this.formData.addressData = this.eventAddressArr
    },

    async initEditData() {
      let resData = await api.eventDetail({
        event_id: this.id
      })
      this.logsArr = resData.event_log
      if(this.models != "look") {
        this.tagsArr = []
      }else {
        this.tagsArr = resData.event_tags
      }
      for(let i = 0 ; i < resData.event_log.length; i++) {
        if(resData.event_log[i].related_news_list.length > 0) {
          this.$set(this.logsArr[i],"bulletin",resData.event_log[i].related_news_list.id + ":" + resData.event_log[i].related_news_list.title)
        }
      }
      // console.log(resData)
      // resData.event_info.event_related_id_expand.item.forEach(item => 
      //   this.conditionSelect(item.risk_info.id)
      // )
      this.processEditData(resData)
    },

    async specialEditData() {
      let resData = await api.logInfo({
        log_id: this.id
      })
      this.tagsArr = resData.info.data.event_tags
      this.processEditData(resData.info.data)
      let res = await api.eventLog({
        event_id: this.$route.query.event_id
      })
      this.logsArr = res.event_log
    },
    
    processEditData(resData) {
      let that = this
      let processObj
      if(this.$route.query.special) {
        processObj  = Object.assign({}, this.formData, resData.event)
      }else {
        processObj  = Object.assign({}, this.formData, resData.event_info)
      }
      

      // 1.3新增更新判断
      if(this.models != "look") {
        processObj.event_source = ""
        processObj.event_source_content = ""
        processObj.event_source_url = ""
      }
      processObj.event_id = processObj.id
      // 组装地址数据
      resData.event_area.forEach(item => {
        let tempObj = this.$_.cloneDeep(this.eventAddressItem)
        tempObj.uuid = this.$commFunc.generateUUID()
        tempObj.address1 = item.id
        let addressStr = item.address || ''
        let addressArr = addressStr.split('/')
        addressArr.forEach((addItem, index) => {
          tempObj['address' + (index + 2)] = addItem
        })
        tempObj.longitude = item.address_lng
        tempObj.latitude = item.address_lat
        this.eventAddressArr.push(tempObj)
      })

      if (!this.eventAddressArr.length) {
        this.addAdressItem()
      }

      processObj.addressData = this.eventAddressArr

      // 时间戳转换成日期
      if (processObj.event_time_start) {
        processObj.event_time_start_str = this.$commFunc.formatDate(processObj.event_time_start)
      }

      if (processObj.event_time_end) {
        processObj.event_time_end_str = this.$commFunc.formatDate(processObj.event_time_end)
      }

      if (processObj.event_affect_time_end) {
        processObj.event_affect_time_end_str = this.$commFunc.formatDate(processObj.event_affect_time_end)
      }

      // 是否为减分项
      if (processObj.event_related_positive_affect == -1) {
        processObj.event_related_id = ''
        processObj.event_related_level = ''
        this.isReduce = 0
      } else {
        this.isReduce = 1
        // 如果减分项性质为正面
        if (processObj.event_related_positive_affect == 1) {
          this.reduceProp = 1
        } else {
          this.reduceProp = 0
        }

        // 如果减分类型为针对型
        if (processObj.event_related_type == 0) {
          processObj.event_related_id_input = processObj.event_related_id
        } else if(processObj.event_related_type == 1){
          processObj.event_related_id_select = processObj.event_related_id
          processObj.event_related_id_select_arr = processObj.event_related_id.split(',').map(item => parseInt(item))
        }else {
          console.log(processObj.event_related_id_expand)
          this.andValue = processObj.event_related_id_expand.type == "||" ? 1:0
          this.conditionalItem = []
          processObj.event_related_id_expand.item.forEach((item,index) =>
            this.conditionalItem.push({
              event: item.risk_info.id,  
              refer: item.risk_field.field_name,
              factor: item.selected  
            })
          )
          // console.log(this.conditionalItem)
        }
      }

      // 多个事件类型id用,隔开转换
      processObj.risk_id_arr = resData.event_risk.map(item => item.id)
      processObj.risk_id = processObj.risk_id_arr.join(',')



      this.isSheHua = processObj.related2china == 1 ? true :false
      this.formData = processObj

      // 获取国家事件风险
      let timer = setInterval(() => {
        if (this.areaDataLoaded) {
          this.getEventFieldOptionList(true, resData)
          clearInterval(timer)
        }
      }, 1000)

      this.$set(this.selectedNewsTable, "data", processObj.related_news_list)
    },

    processEditScoreData(resData) {
      let tempScoreObj = {}
      let that = this
      // 组装选中分值
      resData.event_risk.forEach(item => {
        item.score.forEach(scoreItem => {
          let key = [scoreItem.chinese_special, item.id, scoreItem.risk_field_id].join('_')
          let optionsIdArr = scoreItem.risk_field_value.map(optionItem => optionItem.area_risk_field_option_id)
          tempScoreObj[key] = optionsIdArr
        })
      })
      console.log(this.eventFieldSelect)
      console.log('===============')
      this.eventFieldSelect = tempScoreObj
      console.log('ttttttttt')
      console.log(tempScoreObj)
      console.log(this.eventFieldSelect)
    },

    addressBtnClick(index) {
      if (index == 0) {
        this.addAdressItem();
      } else {
        this.deleteAddressItem(index);
      }
    },

    addAdressItem() {
      let addressItem = this.$_.cloneDeep(this.eventAddressItem)
      addressItem.uuid = this.$commFunc.generateUUID()
      this.eventAddressArr.push(addressItem)
    },

    deleteAddressItem(index) {
      if (this.formData.addressData.length > 1) {
        this.formData.addressData.splice(index, 1);
      } else {
        TipUtil.message("至少保留一个数据", "warning");
      }
    },

    processInvolvedData(prefix) {
      let retArr = [];
      this.$enums.InvolvedType.list.forEach(item => {
        retArr.push({
          key: prefix + item.key,
          text: item.text
        });
      });

      return retArr;
    },

    async getEventFieldOptionList(isEdit, resData) {
      let selectAreaArr = this.formData.addressData
      if (selectAreaArr.length && selectAreaArr[0].address1) {
        if(this.formData.risk_id_arr.length > 0) {
          let cityId = selectAreaArr[0].address1
          let countryId = this.getCountryIdByCity(cityId)
          let res = await api.getEventFieldOptionList({
            area_id: countryId,
            risk_id: this.formData.risk_id_arr.join(',')
          })

           // 保存下拉选项数组值
            this.eventRiskFieldOptions = res.list
            this.eventRiskFieldList = []
            let tempCommonArr = []
            let tempShehuaArr = []

            res.risk_list.forEach(item => {
              let tempCommonObj = this.$_.cloneDeep(item)
              let tempSheHuaObj = this.$_.cloneDeep(item)
              let filterFieldList = res.field_list.filter(fItem => fItem.field_name != '涉事人数' && fItem.field_name != '华人涉事人数' && fItem.risk_id == item.risk_id)

              let commonFieldFilterArr = this.$_.cloneDeep(filterFieldList.filter(fItem => fItem.target_type == 1))
              let shehuaFieldFilterArr = this.$_.cloneDeep(filterFieldList.filter(fItem => fItem.target_type == 2))
              commonFieldFilterArr.forEach(subItem => {
                subItem.option_list = res.list.filter(optItem => optItem.risk_id == item.risk_id && optItem.risk_field_id == subItem.risk_field_id && optItem.target_type == 1)
              })

              shehuaFieldFilterArr.forEach(subItem => {
                subItem.option_list = res.list.filter(optItem => optItem.risk_id == item.risk_id && optItem.risk_field_id == subItem.risk_field_id && optItem.target_type == 2)
              })

              tempCommonObj.field_list = commonFieldFilterArr
              tempSheHuaObj.field_list = shehuaFieldFilterArr

              tempCommonArr.push(tempCommonObj)
              tempShehuaArr.push(tempSheHuaObj)
            })
            this.eventRiskFieldList.push(tempCommonArr)
            this.eventRiskFieldList.push(tempShehuaArr)
        }  
      } else {
        this.eventRiskFieldOptions = []
        this.eventRiskFieldList = []
      }
      this.eventFieldSelect = {}
      if (isEdit && typeof isEdit == 'boolean') {
        this.processEditScoreData(resData)
      }
    },

    // 条件型 - 事件选择
    async conditionSelect(val) {
      // console.log(val)
      // console.log(this.formData)
      let selectAreaArr = this.formData.addressData
      if(selectAreaArr[0].address1) {
        let cityId = selectAreaArr[0].address1
        let countryId = this.getCountryIdByCity(cityId)
        let res = await api.getEventFieldOptionList({
          area_id: countryId,
          risk_id: val
        })
        
        this.eventRiskFieldOptions2 = res.list
        this.eventRiskFieldLists = res.field_list
      }
    },

    getCountryIdByCity(cityId) {
      let retVal = ''
      let findIndex = this.addressSelectData.findIndex(item => item.id == cityId)
      if (findIndex > -1) {
        retVal = this.addressSelectData[findIndex].country_area_id
      }

      return retVal
    },

    openAddNewsTableClick() {
      this.dialogSelectedNewsArr = []
      this.showNewsTableDialog = true
    },

    doSelectedNewsItem(newsIndex) {
      this.selectedNewsTable.data.splice(newsIndex, 1)
    },

    dialogNewsSelectChange(selectedArr) {
      this.dialogSelectedNewsArr = selectedArr
    },

    async getDialogNewsList() {

    },

    confimAddRelatedNews() {
      let selectedData = this.$_.cloneDeep(this.selectedNewsTable.data)
      this.dialogSelectedNewsArr.forEach(item => {
        let findIndex = selectedData.findIndex(fItem => fItem.news_id == item.news_id)
        if (findIndex == -1) {
          selectedData.push(item)
        }
      })
      this.$set(this.selectedNewsTable, "data", selectedData)
      this.showNewsTableDialog = false
    },

    doCancel() {
      this.$router.back()
    },

    doSubmit() {
      if (!this.areaDataLoaded) {
        TipUtil.message('地区数据未加载完，请稍等!', 'warning')
        return false
      }
      this.$refs.myForm.validate(async valid => {
        if (!valid) {
          TipUtil.message('请检查表单!', 'warning')
          return
        }
        let apiFunc = this.isEdit ? api.editEvent : api.addEvent
        let processObj = this.processSubmitData()
        let res = await apiFunc(processObj)
        let msg = this.isEdit ? '修改事件成功' : '新增事件成功'
        TipUtil.message(msg, "success")
        if(this.models != "look") {
          let param
          if(this.id) {
            param = {
              session_id: sessionStorage.getItem("times"),
              event_id: this.id
            }
          }else {
            param = {
              session_id: sessionStorage.getItem("times"),
              event_id: res.event_id
            }
          }
          if(sessionStorage.getItem("times") != null) {
            let datas = await api.tagBind(param)
            if(datas.error_code == 0) {
              sessionStorage.removeItem("times")
              setTimeout(() => {
                this.$router.push('/data-input/eventList')
              }, 200)
            }
          }else {
            setTimeout(() => {
              this.$router.push('/data-input/eventList')
            }, 200)
          }
        }else {
          setTimeout(() => {
            this.$router.push('/data-input/eventList')
          }, 200)
        }
      })
    },

    processSubmitData() {
      let processObj = this.$_.cloneDeep(this.formData)

      // 组装地址数据
      processObj.affect_area_address_lat = processObj.addressData.map(item => item.longitude).join(',')
      processObj.affect_area_id = processObj.addressData.map(item => item.address1).join(',')
      processObj.affect_area_address = processObj.addressData.map(item => {
        return [item.address2,item.address3,item.address4].join('/')
      }).join(',')
      processObj.affect_area_address_lat = processObj.addressData.map(item => item.latitude).join(',')
      processObj.affect_area_address_lng = processObj.addressData.map(item => item.longitude).join(',')

      // 日期转换成时间戳
      processObj.event_time_start = this.$commFunc.parseToTimestamp(processObj.event_time_start_str)
      processObj.event_time_end = this.$commFunc.parseToTimestamp(processObj.event_time_end_str)
      processObj.event_affect_time_end = this.$commFunc.parseToTimestamp(processObj.event_affect_time_end_str)

      // 是否为减分项
      if (this.isReduce == 1) {
        // 如果减分项性质为正面
        if (this.reduceProp == 1) {
          processObj.event_related_positive_affect = 1
        } else {
          processObj.event_related_positive_affect = 0
        }

        // 如果减分类型为针对型
        if (processObj.event_related_type == 0) {
          processObj.event_related_id = processObj.event_related_id_input
        } else if(processObj.event_related_type == 1){
          processObj.event_related_id = processObj.event_related_id_select_arr.join(',')
        } else {
          let str;
          let ifVal = this.andValue == 0? "&&":"||"
          this.conditionalItem.forEach(item => 
            str += item.refer+"="+item.factor + ifVal
          )
          let str1 = str.substr(9)
          let strLast = str1.substr(0,str1.length-2)
          processObj.event_related_id = strLast
        }
      } else {
        processObj.event_related_positive_affect = -1
        processObj.event_related_type = 0
        processObj.event_related_id = ''
        processObj.event_related_level = ''
      }

      // 多个事件类型id用,隔开转换
      processObj.risk_id = processObj.risk_id_arr.join(',')

      // 事件关联风险分类对应值
      this.separateEventFiledSelect(processObj);

      processObj.related2china = this.isSheHua ? 1 : 0
      let selectNewsTempArr = this.selectedNewsTable.data.map(item => item.news_id)
      processObj.related_news_id = selectNewsTempArr.join(',')
      return processObj
    },

    separateEventFiledSelect(processObj) {
      for(let key in this.eventFieldSelect) {
        let keyArr = key.split('_')
        if (keyArr.length && this.eventFieldSelect[key].length > 0) {
          let tempArr = []
          let processKey = `risk_item_value_risk_${keyArr[1]}_field_${keyArr[2]}`
          this.eventFieldSelect[key].forEach(optIt => {
            let filterArr = this.eventRiskFieldOptions.filter(item => item.id == optIt)
            if (filterArr.length) {
              let tempObj = {
                id: filterArr[0].id,
                event_risk_value: filterArr[0].risk_field_value,
                event_risk_score: filterArr[0].risk_field_score
              }
              tempArr.push(tempObj)
              // if(typeId == 0) {
              //   tempArr1.push(tempObj)
              // } else {
              //   tempArr2.push(tempObj)
              // }
            }
          })
          processObj[processKey] = JSON.stringify(tempArr)
        }
      }
    },
    // 参考因素select
    consultFn(val) {
      let arr = this.eventRiskFieldLists.filter(item => item.risk_field_id == val)
      this.eventFieldSelects = this.eventRiskFieldOptions2.filter(item => (item.target_type == arr[0].target_type && item.risk_field_id == arr[0].risk_field_id))
    },
    // 条件型 
    conditionFn(index) {
      if(index == 0) {
        this.conditionAdd()
      }else {
        this.conditionDel(index)
      }
    },
    // 条件 - 新增
    conditionAdd() {
      let datas = {
        event: '',
        refer: '',
        factor: ''
      }
      this.conditionalItem.push(datas)
    },
    // 条件 - 删除
    conditionDel(index) {
      this.conditionalItem.splice(index, 1);
    },
    // 跳转到地区库管理
    goOutPage() {
      let routeData = this.$router.resolve({
        name: "areaList",
        query: {
          add: true
        }
      });
      window.open(routeData.href, '_blank');
    },
    // 刷新缓存
    removeLocalFn() {
      localData.removeLocalAreaList()
      // 获取城市列表
      this.$commFunc.getAreaList().then(resData => {
        this.areaDataLoaded = true
        this.addressSelectData = resData
      })
    },
    newsletterFn() {
      if (!this.areaDataLoaded) {
        TipUtil.message('地区数据未加载完，请稍等!', 'warning')
        return false
      }
      this.$refs.myForm.validate(async valid => {
        if (!valid) {
          TipUtil.message('请检查表单!', 'warning')
          return
        }
        let apiFunc = this.isEdit ? api.editEvent : api.addEvent
        let processObj = this.processSubmitData()
        let res = await apiFunc(processObj)
        let msg = this.isEdit ? '修改事件成功' : '新增事件成功'
        TipUtil.message(msg, "success")
        if(this.models != "look") {
          let param
          if(this.id) {
            param = {
              session_id: sessionStorage.getItem("times"),
              event_id: this.id
            }
          }else {
            param = {
              session_id: sessionStorage.getItem("times"),
              event_id: res.event_id
            }
          }
          if(sessionStorage.getItem("times") != null) {
            let datas = await api.tagBind(param)
            if(datas.error_code == 0) {
              sessionStorage.removeItem("times")
              let urls
              if(this.id) {
                urls = "https://ma.ciwei.com/admin/news/create?event_id="+this.id
              }else {
                urls = "https://ma.ciwei.com/admin/news/create?event_id="+res.event_id
              }
              setTimeout(() => {
               window.location.href = urls;
              }, 200)
            }
          }else {
            let urls
            if(this.id) {
              urls = "https://ma.ciwei.com/admin/news/create?event_id="+this.id
            }else {
              urls = "https://ma.ciwei.com/admin/news/create?event_id="+res.event_id
            }
            setTimeout(() => {
             window.location.href = urls;
            }, 200)
          }
        }
        // else {
        //   setTimeout(() => {
        //     window.open("https://ma.ciwei.com/admin/news/create?event_id="+res.event_id);
        //   }, 200)
        // }
      })
    },

    // 1.3 2020.6.15 新增
    async tagList() {
      let res = await api.tagList()
      if(res.error_code == 0) {
        this.tagListArr = res.list
      }
    },
    async addTagsFn() {
      let res = await api.addTag({
        tag_name: this.tags_name
      })
      this.dialogTags = false
      this.tags_name = ""
      this.tagList()
    },
    // 选中标签
    selectTagFn(val) {
      this.selectTxt = val
    },
    // 复制选中内容
    async copyTextFn() {
      console.log(this.selectTxt)
      
      let text = window.getSelection().toString()
      if(this.selectTxt != "" && text != "") {
        this.tagsArr.push({
          ...this.selectTxt,
          tag_value: text
        })
        let param;
        if(this.models == "look") {
          param = {
            event_id: this.id,
            tag_id: this.selectTxt.id,
            tag_value: text
          }
        }else {
          if(sessionStorage.getItem("times") == null) {
            let times = new Date().getTime()
            sessionStorage.setItem("times",times)
          }
          param = {
            session_id: sessionStorage.getItem("times"),
            tag_id: this.selectTxt.id,
            tag_value: text
          }
        }
        let res = await api.tagEdit(param)
      }
      this.selectTxt = ""

      // console.log(this.tagsArr)
    },
    tagsDelFn(val,index) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let param
        if(this.models == "look") {
          param = {
            event_id: this.id,
            tag_id: val.tag_id || val.id
          }
        }else {
          if(sessionStorage.getItem("times") == null) {
            
          }else {
            param = {
              session_id: sessionStorage.getItem("times"),
              tag_id: val.tag_id || val.id
            }
          }
        }
        console.log(val)
        let res = await api.tagDelete(param)
        // console.log(index)
        this.tagsArr.splice(index,1)

      }).catch(() => {
      });
    },
    lookFn(item) {
      let routeData = this.$router.resolve('/data-input/createEvent?id=' + item.id + '&model=look&special=true&event_id=' + item.event_id)
      window.open(routeData.href, '_blank');
    }
  },
  created() {
    this.tagList()
    this.models = this.$route.query.model
    let id = this.$route.query.id
    if (id) {
      this.id = id
      this.isEdit = true
    }
    this.initCommonData();
    if (this.isEdit) {
      if(this.$route.query.special) {
        this.specialEditData()
      }else {
        this.initEditData();
      }
      
    } else {
      this.initAddData();
    }
  },
  mounted() {},
  beforeDestroy() {}
};
</script>

<style lang="less" scoped>
.condition {
  .el-select {
    margin-right: 10px;
  }
}
.event-risk-wrap {
  padding: 10px 10px 18px;
}
.event-risk-inner {
  padding-bottom: 10px;
  border-bottom: 2px solid #ccc;
  font-size: 16px;
  line-height: 16px;
  display: inline-block;
}
</style>
